const DEFAULT_OLLAMA_HOST = 'localhost:11434'

/**
 * Create Ollama API request function
 * @param {Function} httpRequest - HTTP request function
 * @returns {Object} Object with requestAPI and checkAvailability functions
 */
export function createOllamaUtils(httpRequest) {
  const requestAPI = async ({
    host = DEFAULT_OLLAMA_HOST,
    path,
    method = 'POST',
    body = {},
    timeout = 300000, // 5 minutes for CPU inference
  }) => {
    // Parse host:port
    const [hostname, port] = host.split(':')

    const options = {
      protocol: 'http',
      options: {
        host: hostname,
        port: parseInt(port || '11434', 10),
        path,
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout,
      },
      data: method === 'POST' || method === 'PUT' ? JSON.stringify(body) : '',
    }

    try {
      const resp = await httpRequest(options)

      if (resp.statusCode >= 400) {
        throw new Error(
          `Ollama API error: ${resp.statusCode} - ${JSON.stringify(resp.body)}`,
        )
      }

      return JSON.parse(resp.body)
    } catch (error) {
      if (error.code === 'ECONNREFUSED' || error.message.includes('connect')) {
        throw new Error(
          'Cannot connect to Ollama. Make sure Ollama is running (try: ollama serve)',
        )
      }
      throw error
    }
  }

  const checkAvailability = async (host = DEFAULT_OLLAMA_HOST) => {
    try {
      await requestAPI({
        host,
        path: '/api/tags',
        method: 'GET',
        timeout: 3000,
      })
      return true
    } catch (error) {
      return false
    }
  }

  return { requestAPI, checkAvailability }
}
